import { useCallback, useState } from 'react';

import type { GridApi, GridReadyEvent } from 'ag-grid-enterprise';

export const useAGGridToolbar = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const onGridReady = useCallback((event: GridReadyEvent) => {
    setGridApi(event.api);
  }, []);

  return { gridApi, onGridReady };
};
